export class CtepTerminal {
	ID:string;
	Type:string;
	NickName:string;
	Connected:boolean;

	public constructor(data:any){
		this.ID = data.ID;
		this.Type = data.Type;
		this.NickName = data.NickName;
		this.Connected = data.Connected;
	}

	public toString():string {
		let result = `${this.ID} (${this.Type})`;
		if (this.NickName) {
			result =`${this.NickName} (${this.ID} / ${this.Type})`;
		}
		if (!this.Connected) {
			result = "(Offline) " + result;
		}
		return result;
	}
}